import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Transition as _Transition, withCtx as _withCtx, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "login"
};
const _hoisted_2 = ["src"];
const _hoisted_3 = {
  class: "login-form"
};
const _hoisted_4 = {
  key: 0,
  class: "login-first"
};
const _hoisted_5 = {
  class: "title"
};
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", {
  class: "subTitle"
}, "为方便取得联系，请使用您的常用手机号码", -1);
const _hoisted_7 = {
  class: "mobile-input"
};
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", {
  class: "country-select"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "country"
}, "+86")], -1);
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", {
  class: "separator"
}, null, -1);
const _hoisted_10 = {
  key: 0,
  class: "login-type-1"
};
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "请输入验证码", -1);
const _hoisted_12 = {
  class: "subTitle"
};
const _hoisted_13 = {
  class: "captcha-input"
};
const _hoisted_14 = {
  key: 0,
  class: "login-type-2"
};
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "请输入密码", -1);
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", {
  class: "subTitle"
}, "您的账户已设置密码，继续登录请输入密码", -1);
const _hoisted_17 = {
  class: "password-input"
};
const _hoisted_18 = {
  class: "login-agreement"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_password_input = _resolveComponent("van-password-input");
  const _component_van_button = _resolveComponent("van-button");
  const _component_van_checkbox = _resolveComponent("van-checkbox");
  const _component_van_number_keyboard = _resolveComponent("van-number-keyboard");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("img", {
    class: "login-bg",
    src: require('@/assets/img/login-bg.png')
  }, null, 8, _hoisted_2), _createElementVNode("div", _hoisted_3, [$setup.loginStep === 'login-first' ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, "欢迎使用" + _toDisplayString($options.config.title), 1), _hoisted_6, _createElementVNode("div", _hoisted_7, [_hoisted_8, _hoisted_9, _withDirectives(_createElementVNode("input", {
    class: "input",
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $setup.mobile = $event),
    type: "text",
    placeholder: "请输入手机号码",
    maxlength: "11",
    onInput: _cache[1] || (_cache[1] = (...args) => $options.mobileInputHandle && $options.mobileInputHandle(...args))
  }, null, 544), [[_vModelText, $setup.mobile]])])])) : _createCommentVNode("", true), _createVNode(_Transition, {
    name: "login-step"
  }, {
    default: _withCtx(() => [$setup.loginStep === 'login-type-1' ? (_openBlock(), _createElementBlock("div", _hoisted_10, [_hoisted_11, _createElementVNode("div", _hoisted_12, "验证码已发送至手机 +86" + _toDisplayString($setup.mobile), 1), _createElementVNode("div", _hoisted_13, [_createVNode(_component_van_password_input, {
      info: "验证码为 6 位数字",
      mask: false,
      value: $setup.captcha,
      gutter: 10,
      focused: $setup.showKeyboard,
      onFocus: _cache[2] || (_cache[2] = $event => $setup.showKeyboard = true)
    }, null, 8, ["value", "focused"])])])) : _createCommentVNode("", true)]),
    _: 1
  }), _createVNode(_Transition, {
    name: "login-step"
  }, {
    default: _withCtx(() => [$setup.loginStep === 'login-type-2' ? (_openBlock(), _createElementBlock("div", _hoisted_14, [_hoisted_15, _hoisted_16, _createElementVNode("div", _hoisted_17, [_withDirectives(_createElementVNode("input", {
      class: "input",
      "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $setup.password = $event),
      type: "password",
      placeholder: "请输入账户密码",
      onInput: _cache[4] || (_cache[4] = (...args) => $options.passwordInputHandle && $options.passwordInputHandle(...args))
    }, null, 544), [[_vModelText, $setup.password]])])])) : _createCommentVNode("", true)]),
    _: 1
  }), $setup.loginStep === 'login-first' || $setup.loginStep === 'login-type-2' ? (_openBlock(), _createBlock(_component_van_button, {
    key: 1,
    class: "login-button",
    type: "primary",
    block: "",
    loading: $setup.doing,
    disabled: $setup.loginButtonDisabled,
    onClick: $options.submitLogin
  }, {
    default: _withCtx(() => [_createTextVNode("登录 ")]),
    _: 1
  }, 8, ["loading", "disabled", "onClick"])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_18, [_createVNode(_component_van_checkbox, {
    disabled: !($setup.loginStep === 'login-first'),
    modelValue: $setup.agreementChecked,
    "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => $setup.agreementChecked = $event),
    "checked-color": "#ff9500"
  }, {
    default: _withCtx(() => [_createTextVNode(" 阅读并同意《服务协议》和《个人信息处理规则》 ")]),
    _: 1
  }, 8, ["disabled", "modelValue"])]), _createVNode(_component_van_number_keyboard, {
    modelValue: $setup.captcha,
    "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => $setup.captcha = $event),
    show: $setup.showKeyboard,
    onBlur: _cache[7] || (_cache[7] = $event => $setup.showKeyboard = false)
  }, null, 8, ["modelValue", "show"])]);
}